/** * * Asynchronously loads the component for
AbouteSIM
* */ import { lazyLoad } from "utils/loadable";
export const AbouteSIM = lazyLoad(
  () => import("./index"),
  (module) => module.AbouteSIM
);
